import { Icon, IconProps } from "../Icon";

const Error = (props: IconProps) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 16C2 23.732 8.26801 30 16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16ZM25.15 23.75L8.25 6.85001C13.0182 2.88109 20.0255 3.20093 24.4123 7.58771C28.7991 11.9745 29.1189 18.9818 25.15 23.75ZM8.24 25.16C3.19785 20.8782 2.57165 13.3236 6.84 8.27L23.73 25.16C19.258 28.9387 12.712 28.9387 8.24 25.16Z"
      fill="currentColor"
    />
  </Icon>
);

export default Error;
